/*@ngInject*/
const AppModeConfigurationDirective = function ($document, appTypeConfigurationModel, coreConstant, coreMediator, localization) {

    let linkFunction = function ($scope, $elm, $attrs) {
        function setDocumentTitle(userType) {
            localization.getTranslationByKey(appTypeConfigurationModel.getConsoleTitleKey()).then(function (translation) {
                $document[0].title = translation;
            });
        }

        function setAppUserType() {
            coreMediator.loadUserProfile().then(function (userProfile) {
                let userType = userProfile.userType;
                appTypeConfigurationModel.setUserType(userType);

                setDocumentTitle(userType);

                $scope.$broadcast(coreConstant.event.USERTYPE_UPDATED);
            });
        }

        coreMediator.loadDefaultPreferences().then(function (preferences) {
            setAppUserType();
        });

        $scope.$on(coreConstant.event.LOGOUT_COMPLETE, function (event) {
            appTypeConfigurationModel.clearUserType();
            setDocumentTitle(null);
        });
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umCore')
    .directive('appModeConfiguration', AppModeConfigurationDirective);
